import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store/store";
import vuetify from "@/plugins/vuetify";
import { i18n } from "@/plugins/i18n";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(vuetify);

import * as Firebase from "firebase/app";
import VueAmplitude from "vue-amplitude";

const config = {
  apiKey: "AIzaSyAlAceB0qYuU7K7Bu_JKhqHoZ8eq8D4Jsc",
  authDomain: "auth.boomy.com",
  databaseURL: "https://boomy-app.firebaseio.com",
  projectId: "boomy-app",
  storageBucket: "boomy-app.appspot.com",
  messagingSenderId: "682061990549"
};
Firebase.initializeApp(config);

Vue.config.productionTip = false;

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true
  }
});

//amplitude
Vue.use(VueAmplitude, {
  apiKey: process.env.VUE_APP_AMPLITUDE_KEY,
  config: {
    includeUtm: true,
    includeReferrer: true,
    saveParamsReferrerOncePerSession: false
  }
});

let app;

Firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      i18n,
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }

  if (process.env.NODE_ENV === "development") {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app;
  }
});
